$(function() {
    $(window).scroll(function(){
        if($(window).scrollTop() >= ($('.reservation').offset().top + $('.reservation').height() - $('.reservation-right-inner').height()))
        {
            $('.reservation-right-inner').removeClass('sticky');
            $('.reservation-right').addClass('bottom');
        }
        else if ($(window).scrollTop() >= $('.reservation').offset().top) {
            $('.reservation-right-inner').addClass('sticky');
            $('.reservation-right').removeClass('bottom');
        }
        else {
            $('.reservation-right-inner').removeClass('sticky');
            $('.reservation-right').removeClass('bottom');
        }
    });

    $('.results-item-element-heading').click(function () {
        $(this).closest('.results-item-element').toggleClass('show');
        return false;
    });

    $('#date-picker').datepicker({
        language: url_lang,
        minDate: new Date(),
        position: 'bottom right',
        autoClose : true
    })

    $('#contact-type').change(function(){
        $('.contact-sub-type').addClass('hideform');
        $('.contact-sub-type input').removeAttr('required').val('');
        $('.contact-sub-type select').removeAttr('data-parsley-min').val(0);
        $('.contact-sub-sub-type').addClass('hideform');
        $('.contact-sub-sub-type input').removeAttr('required').val('');
        $('.contact-sub-sub-type select').removeAttr('data-parsley-min').val(0);
        $('.contact-type-'+$(this).val()+'-container').removeClass('hideform');
        $('.contact-type-'+$(this).val()+'-container select').attr('data-parsley-min','1');
        $('.contact-type-'+$(this).val()+'-container input').attr('required','required');
    });

    $('#contact-type-1').change(function(){
        if($(this).val() == 4){
            $('.contact-type-1-4').removeClass('hideform');
        }
        else{
            $('.contact-sub-sub-type').addClass('hideform');
            $('.contact-sub-sub-type input').removeAttr('required').val('');
            $('.contact-sub-sub-type select').removeAttr('data-parsley-min').val(0);
        }
    });

    $('#contact-type-2').change(function(){
        if($(this).val() == 1){
            $( '.contact-type-2-1').removeClass('hideform');
            $( '.contact-type-2-1 select').attr('data-parsley-min','1').val(0);
            $( '.contact-type-2-1 input').attr('required','required').val('');
        }
        else{
            $('.contact-sub-sub-type').addClass('hideform');
            $('.contact-sub-sub-type input').removeAttr('required').val('');
            $('.contact-sub-sub-type select').removeAttr('data-parsley-min').val(0);
        }
    });

    $('#infos-countrycode').bind('focusin', function(e){
        if(e.which !== 8) {
            var numChars = $(this).val().length;
            if(numChars === 0){
                $(this).val('+');
            }
        }
    });


    $('#form-contact').parsley().on('form:submit', function() {
        displayLoader(false);

    });
});